import type { TestSeverity } from '../types';

const SEVERITY_STYLES: Record<TestSeverity, string> = {
    CRITICAL: 'bg-red-100    text-red-700    dark:bg-red-900/40    dark:text-red-300',
    HIGH:     'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300',
    MEDIUM:   'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-300',
    LOW:      'bg-slate-100  text-slate-600  dark:bg-slate-700     dark:text-slate-400',
};

const SEVERITY_LABELS: Record<TestSeverity, string> = {
    CRITICAL: 'Critical',
    HIGH:     'High',
    MEDIUM:   'Medium',
    LOW:      'Low',
};

interface SeverityBadgeProps {
    severity?: TestSeverity | null;
    size?: 'xs' | 'sm';
}

export function SeverityBadge({ severity, size = 'xs' }: SeverityBadgeProps) {
    if (!severity) return null;
    const style   = SEVERITY_STYLES[severity] ?? SEVERITY_STYLES.MEDIUM;
    const label   = SEVERITY_LABELS[severity] ?? severity;
    const sizeClx = size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-xs';

    return (
        <span
            data-testid={`severity-badge-${severity.toLowerCase()}`}
            className={`inline-flex items-center rounded font-semibold ${sizeClx} ${style}`}
        >
            {label}
        </span>
    );
}
